import { BaseMutations } from '@/store/base-mutations';
import { Notifications } from '../types';
import LastNotificationsState from './state';

export default class LastNotificationsMutations extends BaseMutations<LastNotificationsState> {
  SET_LAST_NOTIFICATIONS(notifs: Notifications.Notification[]) {
    this.state.last_notifs = notifs;
  }
}
